import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { getSocket } from "../../../helpers/socket";
import AWS from "aws-sdk";
import Message from "./Message";
import Reply from "./Reply";
import styled from "styled-components";
import AvatarImage from "./AvatarImage";
import MessageRequestCard from "./MessageRequestCard";
import {
  acceptDeclineChat,
  getRoomGroupMembers,
} from "../../../api/apiHandler";
import moment from "moment";
import ParticipantsPopup from "./ParticipantsPopUp";
import { createPortal } from "react-dom";
const Chat = ({
  messagesList,
  selectedChat,
  setMessageList,
  setShowIsJoinPatient,
  queryId,
  checkRoomAvailable,
  handleAcceptRejectReq,
  setInviteType,
  selectedRole,
  setSelectedRole,
  fetchroomSidebarList,
  label,
  setInviteFrom,
  inviteFrom,
  roles,
  status,
  chatSidebar,
  setChatSidebar,
}) => {
  console.log(status, "statusofmonttt");
  const socket = getSocket();
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("user_id");
  const username = localStorage.getItem("user_name");
  const userType = localStorage.getItem("user_login_type_role");
  const chatElementRef = useRef(null);

  const uploadData = async (file, folder_type) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name?.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + folder_type,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };
      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadData:", error);
    }
  };

  useEffect(() => {
    if (!file) {
      setPreview(null);
      setFileType(null);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    if (file.type.startsWith("image/")) {
      setFileType("image");
    } else if (file.type.startsWith("video/")) {
      setFileType("video");
    } else {
      setFileType(null); // unsupported type
    }

    // Cleanup to avoid memory leaks
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    setLoading(true);
    let fileUrl = null;
    let fileType = file?.type;

    if (file) {
      try {
        const fileName = await uploadData(file, "/analysis_file");
        fileUrl = `https://msh-dev.s3.amazonaws.com/analysis_file/${fileName}`;
      } catch (error) {
        console.error("File upload failed", error);
        setLoading(false);
        return;
      }
    }

    const payload = {
      msg: message,
      userId,
      username:
        userType == "2"
          ? "Dr." + username
          : userType == "4"
          ? "Priest " + username
          : "Patient " + username,
      fileUrl,
      fileType,
      chatRoomId: selectedChat.id,
    };

    socket.emit("groupChat", payload);
    setMessage("");
    setFile(null);
    setPreview(null);
    setFileType(null);
    setLoading(false);
    //document.getElementById("formFile").value = "";
  };

  useEffect(() => {
    chatElementRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messagesList]);
  useEffect(() => {
    if (!socket) return;

    const handleGroupMessage = (newMessage) => {
      console.log("Receivedmessage", newMessage);
      if (newMessage?.type === "refreshChatList") {
        // Refresh chat list
        fetchroomSidebarList(label);
      }

      if (newMessage?.chatRoomId) {
        // Message for a specific chat room
        fetchroomSidebarList(label); // Optionally refresh room list
      }
      if (newMessage.type === "groupChatMessage") {
        setMessageList((prevMessages) => [...prevMessages, newMessage]);
      }
      // if (newMessage?.chatRoomId) {
      //   fetchroomSidebarList(label);
      //   setMessageList((prevMessages) => [...prevMessages, newMessage]);
      // } else if (newMessage?.type === "refreshChatList") {
      //   fetchroomSidebarList(label);
      // } else {
      //   console.log("Receivedmessage", newMessage);
      // }
    };

    socket.on("groupChatMessage", handleGroupMessage);

    return () => {
      socket.off("groupChatMessage", handleGroupMessage);
    };
  }, [socket, label]);
  const handleRemove = () => {
    setFile(null);
    setPreview(null);
    setFileType(null);
  };

  const renderMessageWithLinks = (text, from) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text?.split(urlRegex).map((part, index) => {
      if (urlRegex.test(part)) {
        const isYoutube = /(?:youtube\.com|youtu\.be)/.test(part);
        return isYoutube ? (
          <YouTubeLinkPreview key={index} url={part} />
        ) : (
          <RenderLink
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className={`${
              from === "me" ? "Melink" : "themeClr"
            } underline text-break`}
            style={{ textDecoration: "underline" }}
          >
            {part}
          </RenderLink>
        );
      }

      return <span key={index}>{part}</span>;
    });
  };
  console.log(selectedChat, "messagesListssssss2");

  const YouTubeLinkPreview = ({ url }) => {
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    console.log(match, "matchasdasdadd");

    const videoId = match ? match[1] : null;

    if (!videoId) return null;

    const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    // const { hostname } = new URL(url);
    // let favicons = `https://www.google.com/s2/favicons?sz=64&domain=${hostname}`;

    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-decoration-none"
      >
        <div
          className="border rounded overflow-hidden "
          style={{ maxWidth: "340px" }}
        >
          <img
            src={thumbnail}
            alt="YouTube Thumbnail"
            className="img-fluid"
            style={{ display: "block", width: "100%" }}
          />
          <div className="p-2 text-dark bg-light">
            <strong>YouTube Video</strong>

            <p className="text-muted small mb-0">{url}</p>
          </div>
        </div>
      </a>
    );
  };

  console.log(selectedChat, "1234dfvvvv");
  const dateFormat = (date) => {
    const local = moment.utc(date).local();
    return (
      <>
        {local.format("D MMM YYYY")} <small>{local.format("h:mm a")}</small>
      </>
    );
  };
  const [participants, setParticipants] = useState([]);

  const [showPopup, setShowPopup] = useState(false);
  let fetchGroupMembers = async (selectedChat) => {
    console.log(selectedChat, "selectedChat2123456778");
    let data = {
      chat_room_id: selectedChat?.id,
    };

    let responce = await getRoomGroupMembers(data);
    responce = JSON.parse(responce);
    if (responce.code === 200) {
      setParticipants(responce.data);
      setShowPopup(true);
    }
    console.log(responce, "responce4567777");
  };

  const handleChange = (e) => {
    setInviteFrom("");
    const selected = JSON.parse(e.target.value);
    setSelectedRole(selected);
    setShowIsJoinPatient(true);
    setInviteFrom("doctor");
    setInviteType("invite_users");
  };
  console.log(selectedChat, "selectedChat1342d");

  return (
    <>
      {showPopup &&
        createPortal(
          <ParticipantsPopup
            show={showPopup}
            onHide={() => setShowPopup(false)}
            participants={participants}
            selectedChat={selectedChat}
            fetchGroupMembers={fetchGroupMembers}
          />,
          document.body
        )}

      <section
        className={`Chat user-chat-show" `}
        //ref={chatElementRef}
      >
        <div className="SideNavhead d-flex justify-content-between align-content-center ps-0 py-0 pe-3">
          <li className="group">
            <Link className="avatar user-chat-remove flex-shrink-0">
              <AvatarImage
                src={
                  selectedChat?.image
                    ? selectedChat?.image
                    : selectedChat?.user?.profile_image
                    ? selectedChat?.user?.profile_image
                    : "/assets/images/logo.png"
                }
                alt="image"
              />
            </Link>
            <div className="ps-3">
              <p
                className="GroupName p-0"
                style={{ fontSize: 16, lineHeight: 1 }}
              >
                {selectedChat.name
                  ? selectedChat.name
                  : selectedChat?.user?.first_name}
              </p>
              {selectedChat?.is_group === true && (
                <span
                  style={{ fontSize: 14 }}
                  className="text-muted"
                  onClick={() => fetchGroupMembers(selectedChat)}
                >
                  Participants
                </span>
              )}
            </div>
          </li>
          {(localStorage.getItem("user_login_type_role") == "2" ||
            localStorage.getItem("user_login_type_role") == "4" ||
            localStorage.getItem("user_login_type_role") == "3") &&
            selectedChat?.is_group === true &&
            selectedChat?.created_by == localStorage.getItem("user_id") && (
              <div className="mb-3 me-3">
                <label htmlFor="role" className="form-label text-black mb-0">
                  Invite User
                </label>
                <select
                  id="role"
                  className="form-select w-100"
                  value={
                    inviteFrom === "doctor" && selectedRole
                      ? JSON.stringify(selectedRole)
                      : ""
                  }
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select User
                  </option>
                  {roles.map((role) => (
                    <option
                      key={role.id}
                      value={JSON.stringify({ id: role.id, label: role.label })}
                    >
                      {role.label}
                    </option>
                  ))}
                </select>
              </div>

              // </div>
            )}
          <button
            onClick={() => setChatSidebar(!chatSidebar)}
            className="d-lg-none p-0 border-0 bg-transparent mb-3"
          >
            <svg
              width="35"
              height="35"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.63354e-07 5.00002C0.000251341 3.90382 0.360742 2.83808 1.02599 1.96681C1.69124 1.09555 2.62438 0.467057 3.6818 0.178055C4.73922 -0.110947 5.86231 -0.0444386 6.87823 0.367345C7.89415 0.779128 8.74659 1.51336 9.30436 2.45705C9.86213 3.40074 10.0943 4.50158 9.96519 5.59015C9.83606 6.67871 9.35277 7.69468 8.5897 8.48169C7.82663 9.26869 6.82607 9.78312 5.742 9.9458C4.65794 10.1085 3.55046 9.91039 2.59 9.38202L0.646001 9.97402C0.559291 10.0004 0.467033 10.0028 0.379094 9.9808C0.291154 9.95883 0.210842 9.91336 0.146748 9.84927C0.0826539 9.78518 0.0371885 9.70486 0.0152152 9.61692C-0.00675803 9.52898 -0.00441267 9.43673 0.0220005 9.35002L0.614 7.40302C0.210765 6.6663 -0.000398069 5.83987 5.63354e-07 5.00002ZM3 4.50002C3 4.63263 3.05268 4.7598 3.14645 4.85357C3.24022 4.94734 3.36739 5.00002 3.5 5.00002H6.5C6.63261 5.00002 6.75979 4.94734 6.85355 4.85357C6.94732 4.7598 7 4.63263 7 4.50002C7 4.36741 6.94732 4.24023 6.85355 4.14646C6.75979 4.0527 6.63261 4.00002 6.5 4.00002H3.5C3.36739 4.00002 3.24022 4.0527 3.14645 4.14646C3.05268 4.24023 3 4.36741 3 4.50002ZM3.5 6.00002C3.36739 6.00002 3.24022 6.0527 3.14645 6.14646C3.05268 6.24023 3 6.36741 3 6.50002C3 6.63263 3.05268 6.7598 3.14645 6.85357C3.24022 6.94734 3.36739 7.00002 3.5 7.00002H5.5C5.63261 7.00002 5.75979 6.94734 5.85355 6.85357C5.94732 6.7598 6 6.63263 6 6.50002C6 6.36741 5.94732 6.24023 5.85355 6.14646C5.75979 6.0527 5.63261 6.00002 5.5 6.00002H3.5Z"
                fill="#898787"
              />
            </svg>
          </button>
        </div>

        <div className="MessageContainer" id="chatElement">
          <span />
          {messagesList?.map((val, index) => {
            const isImage = val?.fileType?.startsWith("image/");
            return (
              <>
                {Number(val.userId) === Number(userId) &&
                status?.status == "active" ? (
                  <>
                    <div className="py-1">
                      <div className="messageDetails justify-content-center">
                        <div className="messageTime text-muted mx-auto">
                          {new Date(val.createdAt).toLocaleDateString([], {
                            weekday: "short",
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </div>
                      </div>
                      <div className="message me">
                        <p
                          className="messageContent text-white text-start"
                          style={{ fontSize: 12 }}
                        >
                          You ~
                        </p>
                        <div
                          className={`${val?.fileUrl && "video-card"}`}
                          style={{
                            width: val?.fileUrl && 250,
                            background: val?.fileUrl && "#2266b3",
                          }}
                        >
                          {val?.fileUrl &&
                            (isImage ? (
                              <img
                                src={val?.fileUrl}
                                alt=""
                                className="img-fluid rounded w-100 object-fit-contain"
                                style={{ maxHeight: 280 }}
                              />
                            ) : (
                              <video
                                key={val?.id}
                                src={val?.fileUrl}
                                className="img-fluid rounded w-100 object-fit-contain"
                                style={{ height: 280 }}
                                controls
                              />
                            ))}
                          <p className="m-0 title text-muited text-start">
                            {renderMessageWithLinks(val.msg, "me")}
                          </p>
                        </div>
                      </div>

                      <div className="messageDetails">
                        <div className="messageTime text-muted">
                          {dateFormat(val.createdAt)}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  status?.status == "active" && (
                    <>
                      <div className="messageDetails justify-content-center">
                        <div className="messageTime text-muted mx-auto">
                          {new Date(val.createdAt).toLocaleDateString([], {
                            weekday: "short",
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </div>
                      </div>
                      <div className="py-1">
                        <div className="message you">
                          <p
                            onClick={() => {
                              localStorage.getItem("user_login_type_role") ==
                                1 && checkRoomAvailable(val);
                            }}
                            className={`  messageContent text-primary`}
                            style={{
                              fontSize: 12,
                              cursor:
                                localStorage.getItem("user_login_type_role") ==
                                1
                                  ? "pointer"
                                  : "default",
                            }}
                          >
                            ~{val?.username}
                          </p>

                          <div
                            className={`${val?.fileUrl && "video-card"}`}
                            style={{ width: val?.fileUrl && 250 }}
                          >
                            {val?.fileUrl &&
                              (isImage ? (
                                <img
                                  src={val?.fileUrl}
                                  alt=""
                                  className="img-fluid rounded w-100 object-fit-contain"
                                  style={{ maxHeight: 280 }}
                                />
                              ) : (
                                <video
                                  key={val?.id}
                                  src={val?.fileUrl}
                                  className="img-fluid rounded w-100 object-fit-contain"
                                  style={{ height: 280 }}
                                  controls
                                />
                              ))}

                            <p className="mb-0 title">
                              {renderMessageWithLinks(val.msg, "you")}
                            </p>
                          </div>
                        </div>
                        <div className="messageDetails">
                          <div className="messageTime text-muted ms-0 me-auto ps-1">
                            {dateFormat(val.createdAt)}
                          </div>
                        </div>
                      </div>
                    </>
                  )
                )}
              </>
            );
          })}

          {status?.request_declined === true ? (
            <div className="h-100 d-flex align-items-center justify-content-center">
              <p className="m-0 text-dark fw-bold py-2">
                User has declined the request
              </p>
            </div>
          ) : status?.status === "decline" ? (
            <div className="h-100 d-flex align-items-center justify-content-center">
              <p className="m-0 text-dark fw-bold py-2">
                You have declined the chat request
              </p>
            </div>
          ) : (
            messagesList.length === 0 && (
              <div className="h-100 d-flex align-items-center justify-content-center">
                <p className="m-0 text-dark fw-bold py-2">No messages yet</p>
              </div>
            )
          )}

          {status?.status === "pending" && (
            <MessageRequestCard
              senderName={
                selectedChat?.user?.first_name +
                " " +
                selectedChat?.user?.last_name
              }
              messagePreview={"Hey, I’d like to connect with you "}
              chat_room_id={selectedChat.id}
              handleAcceptRejectReq={handleAcceptRejectReq}
            />
          )}
          <div ref={chatElementRef} />
        </div>

        {
          <form
            id="MessageForm"
            className="flex-wrap"
            onSubmit={handleSendMessage}
          >
            {preview && (
              <div
                className="bg-white border p-2 d-flex w-100"
                style={{ gap: 10 }}
              >
                <div className="position-relative">
                  <button
                    className="position-absolute text-danger border-0 p-0 "
                    disabled={loading}
                    style={{
                      top: -8,
                      right: -10,
                      zIndex: 9,
                      background: "#fff",
                      padding: 0,
                      fontSize: 0,
                      lineHeight: 0,
                      margin: 0,
                      height: 17,
                      width: 20,
                    }}
                    type="button"
                    onClick={handleRemove}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 0C3.1 0 0 3.1 0 7C0 10.9 3.1 14 7 14C10.9 14 14 10.9 14 7C14 3.1 10.9 0 7 0ZM9.7 10.5L7 7.8L4.3 10.5L3.5 9.7L6.2 7L3.5 4.3L4.3 3.5L7 6.2L9.7 3.5L10.5 4.3L7.8 7L10.5 9.7L9.7 10.5Z"
                        fill="#E60404"
                      />
                    </svg>
                  </button>
                  {loading && (
                    <img
                      src="/assets/images/loading.gif"
                      alt="Loading"
                      style={{
                        height: 40,
                        top: "50%",
                        transform: "translateY(-50%)",
                        right: 0,
                        left: 0,
                      }}
                      className="img-fluid object-fit-contain position-absolute mx-auto"
                      referrerPolicy="no-referrer"
                    />
                  )}
                  {preview && fileType === "image" && (
                    <img
                      src={preview}
                      style={{ height: 70, width: 70 }}
                      alt=""
                      className="img-fluid rounded object-fit-over"
                    />
                  )}
                  {preview && fileType === "video" && (
                    <video
                      key={preview}
                      src={preview}
                      className="img-fluid rounded object-fit-contain"
                      style={{ maxWidth: 240, maxHeight: 240 }}
                      controls
                    />
                  )}
                </div>
              </div>
            )}

            {((status?.status == "active" &&
              status?.request_declined === false) ||
              status?.request_declined === null) && (
              <>
                <div className="chat-input-group">
                  <input
                    type="text"
                    placeholder="Enter Message..."
                    id="MessageInput"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        if (message.trim() || file) {
                          handleSendMessage(e);
                        }
                      }
                    }}
                  />
                  <span className="input-group-text p-0" id="basic-addon2">
                    <label htmlFor="formFile" className="form-label mb-0">
                      <i className="fa-solid fa-paperclip font_18" />
                    </label>
                    <input
                      className="form-control d-none"
                      type="file"
                      id="formFile"
                      onChange={(e) => setFile(e.target.files[0])}
                    />
                  </span>
                </div>
                <button
                  className="Send"
                  type="submit"
                  disabled={loading || (!message.trim() && !file)}
                >
                  <i className="fa-solid fa-paper-plane" />
                </button>
              </>
            )}
          </form>
        }
      </section>
    </>
  );
};

const RenderLink = styled.a`
  &.Melink {
    transition: 0.4s;
    &:hover {
      color: #fff;
    }
  }
`;
export default Chat;
